import React, { useRef, useState } from 'react'
import { Modal, Button, TextField } from '@ui'
import { OrgTree, useOrgTree } from '../components/OrgTree'

export function OrgPage() {
  const { tree, orphans, loading, error, assignManager, reload } = useOrgTree()
  const [selectedNode, setSelectedNode] = useState(null)
  const [assignTarget, setAssignTarget] = useState(null)
  const [newManagerId, setNewManagerId] = useState('')
  const inputRef = useRef(null)

  async function handleAssign(e) {
    e.preventDefault()
    if (!assignTarget || !newManagerId) return
    await assignManager(assignTarget.userId, newManagerId)
    setAssignTarget(null)
    setNewManagerId('')
  }

  return (
    <div>
      <div style={styles.header}>
        <h2 style={styles.title}>Org structure</h2>
      </div>

      <OrgTree
        tree={tree}
        orphans={orphans}
        loading={loading}
        error={error}
        onRetry={reload}
        onSelect={setSelectedNode}
        onAssignManager={(u) => setAssignTarget(u)}
      />

      <Modal
        open={!!assignTarget}
        onClose={() => setAssignTarget(null)}
        title={assignTarget ? `Assign manager for ${assignTarget.name}` : ''}
        width="sm"
        initialFocusRef={inputRef}
      >
        <form
          onSubmit={handleAssign}
          style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}
        >
          <TextField
            ref={inputRef}
            label="Manager user ID"
            value={newManagerId}
            onChange={(e) => setNewManagerId(e.target.value)}
            required
          />
          <div className="modal__actions">
            <Button variant="secondary" onClick={() => setAssignTarget(null)}>Cancel</Button>
            <Button type="submit">Assign</Button>
          </div>
        </form>
      </Modal>
    </div>
  )
}

const styles = {
  header: { marginBottom: 24 },
  title: { fontSize: 20, fontWeight: 600 },
}
